import { useEffect, useState } from "react";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  getCommunityProjectForm,
  getProjectSearch,
  searchAllProjects,
} from "../../API/store/actions/projects/projects";
import Lang from "../../userPreferences/staticWords";
import ProjectCard from "./projectCard";
import Paginate from "./../layout/paginate";
import Titlebar from "../layout/titlebar";
import {
  englishDate,
  ScrollToTop,
  setCurrentPageandResetData,
} from "../../algorithms";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import CreateNewProject from "./createNewProjectPopup";
import { useSelector } from "react-redux";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import TextInput from "../sharedComponents/inputs/textInput";
import DateInput from "../sharedComponents/datesInputs/date";
import StatusSection from "../reusableComponents/statusSection";
import Slide from "react-reveal/Slide";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import LoadingPopup from "../layout/loadingPopup";

const Projects = () => {
  const [projects, setProjects] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [projAdded, setProjAdded] = useState(false);
  const [show, setShow] = useState(false);
  const userToken = useSelector((state) => state.login.userToken);
  const communityId = useSelector((state) => state.community.communityId?.id);
  const onShow = () => {
    setShow(true);
  };
  const community = useSelector((state) => state.community.communityId);
  const [searchText, setSearchText] = useState("");
  const [prioritySearch, setPrioritySearch] = useState(null);
  const [projectStatusSearch, setTaskStatusSearch] = useState(1);
  const [membersSearch, setMembersSearch] = useState(null);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  useEffect(() => {
    resolver(
      searchAllProjects,
      setProjects,
      communityId,
      currentPage,
      4,
      {
        name: searchText,
        memberId: membersSearch
          ? membersSearch == 0
            ? null
            : membersSearch
          : null,
        priorityId: prioritySearch
          ? prioritySearch == 0
            ? null
            : prioritySearch
          : null,
        projectStatusId: projectStatusSearch == 0 ? null : projectStatusSearch,
        startDate: StartDate ? englishDate(StartDate) : null,
        endDate: EndDate ? englishDate(EndDate) : null,
      },
      userToken,
    );
    ScrollToTop();
  }, [
    currentPage,
    searchText,
    projAdded,
    communityId,
    prioritySearch,
    projectStatusSearch,
    membersSearch,
    StartDate,
    EndDate,
  ]);
  const [AdminMembersList, setAdminMembersList] = useState([]);
  const [MemberList, setMemberList] = useState([]);
  const [ProjectStatusDropdownList, setProjectStatusDropdownList] = useState(
    [],
  );
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);
  const [ProjectTypeDropdownList, setProjectTypeDropdownList] = useState([]);

  const [searchDropdowns, setSearchDrobdowns] = useState({});

  useEffect(() => {
    resolver(getProjectSearch, setSearchDrobdowns, communityId, userToken);
  }, [communityId]);

  useEffect(() => {
    if (searchDropdowns?.data?.members) {
      setAdminMembersList(searchDropdowns?.data?.members);
      setMemberList(searchDropdowns?.data?.members);
    }
    if (searchDropdowns?.data?.priorityLkp)
      setPriorityDropdownList(searchDropdowns?.data?.priorityLkp);
    if (searchDropdowns?.data?.projectStatusLkp)
      setProjectStatusDropdownList(searchDropdowns?.data?.projectStatusLkp);
    if (searchDropdowns?.data?.projectTypeLkp)
      setProjectTypeDropdownList(searchDropdowns?.data?.projectTypeLkp);
  }, [searchDropdowns]);

  const renderModal = () => {
    return (
      <CreateNewProject
        communityId={communityId} //when we put communities
        setProjAdded={setProjAdded}
        projAdded={projAdded}
        show={show}
        onHide={() => setShow(false)}
      />
    );
  };

  const priorityList = [...PriorityDropdownList];
  const projectStatusList = [...ProjectStatusDropdownList];
  const membersList = [...AdminMembersList];

  priorityList.unshift({
    name: getDir(getCurrentLangFromRedux()) == "rtl" ? "الكل" : "All",
    id: 0,
  });
  projectStatusList.unshift({
    name: getDir(getCurrentLangFromRedux()) == "rtl" ? "الكل" : "All",
    id: 0,
  });
  membersList.unshift({
    memberName: getDir(getCurrentLangFromRedux()) == "rtl" ? "الكل" : "All",
    memberId: 0,
  });

  const [showSearch, setShowSearch] = useState(false);

  const [showDropdown, setShowDropdown] = useState({
    id: null,
    display: false,
  });

  if (searchDropdowns?.data)
    return (
      <div className="d-flex flex-column w-100">
        <Titlebar
          title={Lang.projectsNavTab}
          customImage={"/assets/images/icons/projection-screen.png"}
        />
        <StatusSection
          isTask={false}
          communityId={communityId}
          userToken={userToken}
        />
        <hr className="m-0" />
        <div className="d-lg-none col-12 d-flex justify-content-center align-items-center mt-4">
          {/* small screens button */}
          {community?.adminProject && (
            <CardWithTitleAndIcon
              containerStyle="d-flex justify-content-center align-items-center col-10 align-self-center"
              borderColor={"rgba(68, 68, 68, 0.25)"}
              height={90}
              width={230}
              onClick={() => {
                onShow();
              }}
              customImage={"/assets/images/Group 8261.png"}
              imgHeight={50}
              imgWidth={60}
              containerImgHeight={50}
              containerImgWidth={60}
              cardTitle={Lang.addProject}
              boxShadow={"6px 6px 12px 0px rgb(0 0 0 / 20%)"}
            />
          )}

          <div
            className={`d-flex col-2 justify-content-center align-items-center align-self-center my-2 my-md-0`}
            style={{ zIndex: 10 }}
            title={
              getDir(getCurrentLangFromRedux()) == "rtl" ? "بحث" : "Search"
            }
          >
            <div
              className={`mx-2 d-flex justify-content-center align-items-center ${
                showSearch == true ? "backgroundEffect" : "bg-white"
              }`}
              style={{
                border: "1px solid rgba(199, 199, 201, 1)",
                borderRadius: "50%",
                height: 40,
                width: 40,
                cursor: "pointer",
              }}
              onClick={() => {
                setShowSearch(!showSearch);
              }}
            >
              <img
                className={`${showSearch == true ? "filterEffect" : ""}`}
                src="/assets/images/filter.svg"
                width={20}
                height={20}
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          className={`d-lg-flex d-none col justify-content-end my-2 my-md-0 ${customStyle(
            "filterIcon",
          )}`}
          style={{ zIndex: 10 }}
          title={getDir(getCurrentLangFromRedux()) == "rtl" ? "بحث" : "Search"}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              cursor: "pointer",
              zIndex: 10,
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>

        {/* search Input Start */}
        {showSearch && (
          <Slide left opposite collapse when={showSearch}>
            <div
              className={`d-flex flex-column ${styleStart(
                "p",
                4,
                "lg",
              )} ${styleEnd(
                "p",
                5,
                "lg",
              )} justify-content-center justify-content-lg-start align-items-center align-items-lg-start mt-3 align-items-center`}
            >
              <div className="d-flex flex-lg-row flex-column col-lg-8 col-11">
                <TextInput
                  value={searchText}
                  iconName={"search"}
                  iconSize={16}
                  iconPrefix={"fas"}
                  hiddenPlaceholder={Lang.projectName}
                  type={"text"}
                  style={{ padding: "21.5px" }}
                  containerStyle={`col-lg-6 col-12 mb-3 ${styleEnd("m", 3)}`}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                    // dispatch(projectSearchKey(e.target.value));
                  }}
                />
                <DropDownList
                  placeholder={Lang.priority}
                  border={true}
                  containerStyle={`col-12 mb-3 mb-lg-0 col-lg-3 ${styleEnd(
                    "p",
                    2,
                    "lg",
                  )} ${styleEnd("m", 2, "lg")}`}
                  dataSource={priorityList}
                  change={(e) => {
                    setCurrentPage(1);
                    setPrioritySearch(e.value);
                  }}
                />

                <DropDownList
                  placeholder={Lang.projectStatus}
                  border={true}
                  containerStyle={`col-12 mb-3 mb-lg-0 col-lg-3 ${styleEnd(
                    "p",
                    2,
                    "lg",
                  )}`}
                  dataSource={projectStatusList}
                  change={(e) => {
                    setCurrentPage(1);
                    setTaskStatusSearch(e.value);
                  }}
                />
              </div>
              <div className="d-flex flex-lg-row justify-content-start align-items-center col-11 col-lg-8 flex-column">
                <div className="d-flex col-12 col-lg-6 flex-lg-row flex-column align-items-center align-items-lg-start mt-lg-2 mt-0 px-0">
                  <div
                    className={`col-12 mb-3 mb-lg-0 col-lg-6 ${styleEnd(
                      "p",
                      3,
                      "lg",
                    )}`}
                  >
                    <div className="col-12 align-items-center align-items-xl-start">
                      <DateInput
                        errorMessage={
                          startDateError === true ? Lang.invalidDate : null
                        }
                        style={{ padding: "21px" }}
                        placeholder={Lang.from}
                        containerStyle={"col-12"}
                        name={"StartDate"}
                        value={StartDate}
                        onChange={(e) => {
                          if (e) {
                            setStartDate(e);
                            if (!EndDate || (EndDate && e <= EndDate)) {
                              setStartDateError(false);
                              setEndDateError(false);
                            } else {
                              setStartDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (StartDate != "") {
                            setStartDate("");
                            setStartDateError(false);
                          }
                        }}
                        iconPrefix={StartDate == "" ? "far" : "fas"}
                        iconName={StartDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                    {/* {startDateError === true ? (
                  <div>
                    <p className="my-2 text-danger">{Lang.invalidDate}</p>
                  </div>
                ) : null} */}
                  </div>

                  <div className={`col-12 mb-3 mb-lg-0 col-lg-6 `}>
                    <div className="col-12 align-items-center">
                      <DateInput
                        errorMessage={
                          endDateError === true ? Lang.invalidDate : null
                        }
                        placeholder={Lang.to}
                        containerStyle={"col-12"}
                        style={{ padding: "21px" }}
                        value={EndDate}
                        onChange={(e) => {
                          if (e) {
                            setEndDate(e);
                            if (!StartDate || (StartDate && e >= StartDate)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else {
                              setEndDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (EndDate != "") {
                            setEndDate("");
                            setEndDateError(false);
                          }
                        }}
                        iconPrefix={EndDate == "" ? "far" : "fas"}
                        iconName={EndDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                    {/* {endDateError === true ? (
                  <div>
                    <p className="my-2 text-danger">{Lang.invalidDate}</p>
                  </div>
                ) : null} */}
                  </div>
                </div>

                <DropDownList
                  field={{ text: "memberName", value: "memberId" }}
                  placeholder={Lang.Members}
                  border={true}
                  containerStyle={`col-12 mb-3 mb-lg-0 col-lg-6 ${styleStart(
                    "m",
                    3,
                    "lg",
                  )}`}
                  dataSource={membersList}
                  change={(e) => {
                    setCurrentPage(1);
                    setMembersSearch(e.value);
                  }}
                />
              </div>
            </div>
          </Slide>
        )}
        {searchText ? (
          <div
            className={`d-flex ${styleStart(
              "p",
              5,
              "md",
            )} justify-content-center justify-content-lg-start mt-3 align-items-center `}
          >
            <span className=" fw-bold">نتائج البحث عن</span>: {searchText}{" "}
          </div>
        ) : null}
        {/* search Input End */}
        <div className="d-flex flex-column flex-lg-row w-100 align-items-center px-3 pt-2">
          <div className="col-lg-8 col-12 d-flex flex-wrap align-items-stretch">
            {projects?.data?.map((project, index) => {
              return (
                <ProjectCard
                  key={index}
                  communityId={communityId}
                  userToken={userToken}
                  project={project}
                  index={index}
                  setProjAdded={setProjAdded}
                  projAdded={projAdded}
                  setshow={setShowDropdown}
                  show={showDropdown}
                  check={showDropdown.id == project.id ? true : false}
                />
              );
            })}
            {/* lg screens button */}
            {community?.adminProject && (
              <CardWithTitleAndIcon
                containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
                  "createTaskButton",
                )}`}
                borderColor={"rgba(68, 68, 68, 0.25)"}
                height={180}
                width={180}
                onClick={() => {
                  onShow();
                }}
                customImage={"/assets/images/Group 8261.png"}
                imgHeight={70}
                imgWidth={90}
                containerImgHeight={70}
                containerImgWidth={90}
                cardTitle={Lang.addProject}
                boxShadow={"6px 6px 12px 0px rgb(0 0 0 / 20%)"}
              />
            )}

            {/* pagination */}
            {projects?.count > 0 ? (
              <div className="my-3 d-flex justify-content-center col-12">
                <Paginate
                  pageCount={Math.ceil(projects?.count / 4)}
                  currentPage={currentPage}
                  clearData={undefined}
                  setCurrentPage={setCurrentPage}
                  setCurrentPageandResetData={setCurrentPageandResetData}
                />
              </div>
            ) : null}
            {/* end agination */}
          </div>
          {/* <div className=" col-lg-4 col-12"></div> */}
        </div>
        {renderModal()}
      </div>
    );
  return <LoadingPopup show={true} />;
};

export default Projects;
